export const validateName = (value: string) => {
  const isValid = /^[A-Za-z0-9 \-\']+$/.test(value)

  let error: string | null = null
  if (!isValid) error = 'Must only use word characters'

  if (error) return Promise.reject(new Error(error))
  else return Promise.resolve()
}
